import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from 'src/app/app.config';

export interface AppLogoDetails {
  appLogoUrl: string;
  appHeaderMessage: string;
}
@Component({
  selector: 'app-left-side',
  templateUrl: './left-side.component.html',
  styleUrls: ['./left-side.component.scss']
})
export class LeftSideComponent implements OnInit {
  clientLogo?: string;
  clientName?: string;

  constructor(private config: AppConfig, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const clientId = this.route.snapshot.queryParams['client_id'];

    if (clientId) {
      void this.loadClientContext(clientId);
    }
  }

  private async loadClientContext(clientId: string): Promise<void> {
    const client = await this.config.loadClientContext(clientId);

    if (client) {
      this.clientName = client.name;
      this.clientLogo = client.alternateLogoUrl || client.logoUrl || undefined;
    }
  }
}
